import React, { ReactNode } from 'react';

import classes from './page.module.css';

type PageProps = {
  children: ReactNode;
  'data-testid'?: string;
};

export const Page = ({ children, 'data-testid': dataTestId }: PageProps) => {
  return (
    <div className={classes.page} data-testid={dataTestId}>
      {children}
    </div>
  );
};
